/*
* GForm
*/

function fnGform(i, oSection) {

    function fnForm() {

        /*Focused Field*/
        $('form li.gfield.gfield_address input , form li.gfield textarea, form li.gfield select').focusin(function () {

            $(this).closest('span').find('label:not(.is-fixed)').addClass('is-active');

        }).focusout(function () {

            if ($(this).val() == '') {

                $(this).closest('.gfield').find('label:not(.is-fixed)').removeClass('is-active');
            }
        });

        var $not_gf_address = $('form li.gfield').not('.gfield_address');
        $not_gf_address.find('input , textarea, select').focusin(function () {
            $(this).closest('.gfield').find('label:not(.is-fixed)').addClass('is-active');

        }).focusout(function () {

            if ($(this).val() == '') {

                $(this).closest('.gfield').find('label:not(.is-fixed)').removeClass('is-active');
            }
        });

        /*Select Field Label Class*/
        $('.ginput_container_select').each(function () {
            $(this).siblings('.gfield_label').addClass('select-field');
        });

        $(oSection).find('.ginput_container_radio, .ginput_container_checkbox, .ginput_container_fileupload').siblings('label').addClass('is-fixed');

    }

    fnForm();


    $(document).bind('gform_post_render', function (event, formId) {
        fnForm();
        $('select').dropkick({mobile: true});                     // Select drop-down styling (Dropkick.js)
    });


}